var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4886 6.13975C14.6471 6.5095 14.5686 6.93825 14.2893 7.22775C13.3068 8.2465 10.9716 10.6685 9.43983 12.257C9.06282 12.648 8.54307 12.8687 8.00007 12.8687C7.45707 12.8687 6.93732 12.648 6.56032 12.257C5.02857 10.6685 2.69332 8.2465 1.71083 7.22775C1.43158 6.93825 1.35308 6.5095 1.51158 6.13975C1.78633 5.4985 2.21608 4.49575 2.49033 3.856C2.64783 3.4885 3.00932 3.25 3.40957 3.25C5.29657 3.25 10.7036 3.25 12.5906 3.25C12.9908 3.25 13.3523 3.4885 13.5098 3.856C13.7841 4.49575 14.2138 5.4985 14.4886 6.13975Z",
    fill: "url(#paint0_linear_17523_34229)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5687 6.5C14.5777 6.7655 14.4805 7.02925 14.2892 7.22775C13.3067 8.2465 10.9715 10.6685 9.43974 12.257C9.06274 12.648 8.54299 12.8687 7.99999 12.8687C7.45699 12.8687 6.93724 12.648 6.56024 12.257C5.02849 10.6685 2.69324 8.2465 1.71074 7.22775C1.51949 7.02925 1.42224 6.7655 1.43124 6.5H14.5687Z",
    fill: "url(#paint1_linear_17523_34229)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3949 6.38375C11.4624 6.6195 11.4407 6.872 11.3339 7.093C10.8854 8.02275 9.62394 10.6355 8.78769 12.3678C8.64169 12.6702 8.33544 12.8623 7.99969 12.8623C7.66394 12.8623 7.35769 12.6702 7.21169 12.3678C6.37544 10.6355 5.11394 8.02275 4.66544 7.093C4.55869 6.872 4.53694 6.6195 4.60444 6.38375C4.86069 5.486 5.49969 3.25 5.49969 3.25H10.4997C10.4997 3.25 11.1387 5.486 11.3949 6.38375Z",
    fill: "url(#paint2_linear_17523_34229)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17523_34229",
    x1: 8.25007,
    y1: 3.25,
    x2: 8.25007,
    y2: 8.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6266F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17523_34229",
    x1: 9.24999,
    y1: 5.75,
    x2: 8.74999,
    y2: 12.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6266F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17523_34229",
    x1: 7.99976,
    y1: 7.5,
    x2: 7.99969,
    y2: 12.8623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B71FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiamond);
export default __webpack_public_path__ + "static/media/icon-diamond.65d257a33182990552211c709853fa21.svg";
export { ForwardRef as ReactComponent };